<template>
  <div
    class="back_top_dialog"
    :style="styleObj"
  >
    <div class="back_top_dialog_frame">
      <div
        class="close_edit_panel_btn"
        @click="dialog_close"
      >
        <i class="close_edit_panel_icon el-icon-close"></i>
      </div>
      <div class="back_top_dialog_content">
        <div class="layout_row_edit">
          <el-tabs class="edit_top_tabs">
            <el-tab-pane :label="$t('view_back_top_edit_94')">
              <!--移动端下的布局设置-->
              <div class="edit_item">
                <my_radio
                  titleWidth="65"
                  :option="option"
                  :selectValue.sync="selectValue"
                  :title="$t('view_back_top_edit_95')"
                  @change="buttonStyleChange"
                  tips
                  iconIsShow="right"
                  class="m-lr-0"
                >
                </my_radio>
              </div>
              <div
                class="edit_content_list"
                v-if="selectValue == 'default' && editIconList.length"
              >
                <div
                  class="back_top_list"
                  :class="{'active': iconActive == item.id }"
                  v-for="(item,index) in editIconList"
                  :key="index"
                  @click="checkIcon(item,index)"
                >
                  <span
                    class="icon_list_com"
                    :class="item.iconName"
                    :style="{
                        borderRadius:item.borderRadius,
                        backgroundColor:item.id !=='default-0' && item.id !=='default-1' ? '' : item.backgroundColor,
                        color:item.color
                        }"
                  ></span>
                  <div
                    class="icon_checked_icon"
                    v-if="iconActive == item.id "
                  >
                    <span class="el-icon-check"></span>
                  </div>
                </div>
              </div>
              <div style="padding-left:20px;">
                <my_img_button
                  v-if="selectValue == 'custom'"
                  titleWidth="62"
                  :title="$t('view_back_top_edit_96')"
                  :buttonTitle="$t('view_back_top_edit_97')"
                  tipsWidth="250"
                  type="one_level"
                  :tips="$t('view_back_top_edit_98')"
                  @update:imgUrl="imgUrlChange"
                  @uploadImg="uploadImg"
                  :imgUrl.sync="imgUrl"
                ></my_img_button>
                <!-- <my_img_cover :firstModel.sync="imgUrl"></my_img_cover> -->
              </div>

              <my_radio
                titleWidth="70"
                v-if="selectValue == 'default' && showColorRadio"
                :option="option1"
                :selectValue.sync="selectValue1"
                @change="buttonStyleChange1"
                :title="$t('view_back_top_edit_99')"
                tips
                iconIsShow="right"
              >
                <div
                  class=""
                  @click="showColorDiv($event)"
                  style="display:inline-block;"
                  slot="pull_down_control"
                >
                  <my_color
                    @update:color="changeColor"
                    titleWidth="62"
                    type="one_level"
                    :color.sync="customColor"
                    :title="$t('view_back_top_edit_100')"
                    class="select_color"
                  ></my_color>
                </div>
              </my_radio>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import i18n from '../../language/index'

export default {
  name: "back_to_top_edit",
  props: {
    styleObj: {
      type: Object,
      default: function () {
        return { bottom: '70px', right: '90px' }
      }
    },
    iconList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      selectValue: 'default',
      selectValue1: 'default',
      iconActive: 'default-0',
      showColorRadio: true,
      option: [{
        value: 'default',
        label: i18n.t('view_back_top_edit_101')
      },
      {
        value: 'custom',
        label: i18n.t('view_back_top_edit_102')
      }],
      option1: [{
        value: 'default',
        label: i18n.t('view_back_top_edit_103')
      },
      {
        value: 'custom',
        label: i18n.t('view_back_top_edit_102')
      }],
      imgUrl: '',
      editIconList: this.iconList,
      customColor: 'rgba(0, 0, 0,1)',
      defaultColor: ''
    }
  },
  computed: {
    back_top_style_edit () {
      return this.$store.state.myRender.common.fixed_back_top
    }
  },
  methods: {
    findIconIndex (origin, target) {
      for (let index = 0; index < origin.length; index++) {
        let element = origin[index];
        if (target.id && element.id == target.id) {
          this.iconActive = element.id
          this.showColorRadio = element.canChangeColor

          break;
        }
      }

    },
    setIconListStyle (color) {
      this.editIconList.forEach((item, index) => {
        if (item.canChangeColor === true && (item.id === 'default-0' || item.id === 'default-1')) {
          this.$set(this.editIconList[index], "backgroundColor", color)
          this.iconActive == item.id && this.$emit("changeIcon", item)
        }

      })
    },
    dialog_close () {
      this.$emit('changeShow')
    },
    buttonStyleChange (val) {
      this.back_top_style_edit.button_style = val
    },
    buttonStyleChange1 (val) {
      this.defaultColor = this.$store.state.myRender.common.theme_color
      const fn = v => {
        val === 'default'
          ? this.back_top_style_edit.button_color.default.backgroundColor = v
          : this.back_top_style_edit.customColor = v
        this.setIconListStyle(v)
      }
      val === 'default' ?
        fn(this.defaultColor)
        : fn(this.customColor)

      this.back_top_style_edit.button_color.radio_val = val === 'custom' ? 'customize' : val
    },
    checkIcon (item, index) {
      this.iconActive = item.id
      this.showColorRadio = item.canChangeColor
      this.$emit("changeIcon", item)
    },
    changeColor (val) {
      this.customColor = val
      this.back_top_style_edit.customColor = val
      this.setIconListStyle(val)
    },
    showColorDiv (e) {
      this.$nextTick(() => {
        let my_picker = document.querySelector('.my_picker');
        if (my_picker) {
          const pH = my_picker.clientHeight
          const pW = my_picker.clientWidth
          const gapX = document.body.clientWidth - e.clientX
          const gapY = document.body.clientHeight - e.clientY
          my_picker.style.top = `${e.clientY - pH / 2}px`
          my_picker.style.left = `${e.clientX + 16}px`
          if (pW + 16 > gapX) {
            my_picker.style.left = `${e.clientX - pW - 16}px`
          }
        }
      })
    },
    imgUrlChange (val) {
      this.back_top_style_edit.button_color.custom.url = val
    },
    uploadImg () {
      this.$store.commit('image_upload/set_showTag', true);
      this.$store.commit('image_upload/set_fileType', 1);
      this.$store.commit('image_upload/set_fileLimit', 1);
      this.$store.state.image_upload.imgFile = (e) => {
        this.imgUrl = e && e[0].filePath;
        this.$store.state.image_upload.imgFile = null
      }
    },
  },
  mounted () {
    let tempObj = this.back_top_style_edit
    let tempbt = tempObj.button_color
    this.customColor = tempObj.customColor
    this.selectValue = tempObj.button_style
    this.selectValue1 = tempbt.radio_val === 'customize' ? 'custom' : tempbt.radio_val
    this.imgUrl = tempbt.custom.url
    // console.log(tempbt.custom)
    // console.log(this.imgUrl)
    this.findIconIndex(this.iconList, tempbt.default)
    this.defaultColor = this.$store.state.myRender.common.theme_color
    this.setIconListStyle(this.defaultColor)
    //框拖拽
    $('.back_top_dialog').draggable({
      containment: 'window',
    })
    this.buttonStyleChange1(this.selectValue1)
  },
  watch: {
    '$store.state.myRender.common.theme_color' (v) {
      if (this.back_top_style_edit.button_color.radio_val === 'default') {
        this.defaultColor = v
        if (this.iconActive === 'default-0' || this.iconActive === 'default-1') this.back_top_style_edit.button_color.default.backgroundColor = v
        this.setIconListStyle(v)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.back_top_dialog {
  position: fixed;
  width: 380px;
  max-height: 500px;
  height: -webkit-calc(100% - 80px);
  height: -moz-calc(100% - 80px);
  height: calc(100% - 80px);
  background: #fff;
  border-radius: 5px;
  overflow: hidden;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  z-index: 2002;
  .back_top_dialog_frame {
    position: relative;
    width: 100%;
    height: 100%;
    /*overflow-y: auto;*/
    .close_edit_panel_btn {
      position: absolute;
      top: 0;
      right: 0;
      width: 65px;
      height: 65px;
      cursor: pointer;
      line-height: 58px;
      font-size: 30px;
      text-align: center;
      z-index: 10;
      color: #fff;
      i {
        font-size: 23px;
      }
    }
    .back_top_dialog_content {
      height: 100%;
      .edit_content_list {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 30px;
        .back_top_list {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          flex: 0 1 78px;
          height: 78px;
          margin: 0 12px 10px;
          box-sizing: border-box;
          overflow: hidden;
          border-radius: 2px;
          border: 1px solid rgb(248, 242, 242);
          cursor: pointer;
          &:hover {
            border: 1px solid #5874d8;
          }
          &.active {
            border: 1px solid #5874d8;
          }
          .icon_list_com {
            width: 48px;
            height: 48px;
            line-height: 48px;
            font-size: 24px;
            text-align: center;
            color: #fff;
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
          }
          .icon_checked_icon {
            position: absolute;
            right: -15px;
            bottom: -15px;
            height: 30px;
            width: 30px;
            font-size: 0;
            border-radius: 50%;
            background-color: #5874d8;
            span {
              display: inline-block;
              margin: 3px 0 0 3px;
              font-size: 12px;
              font-weight: bold;
              color: #fff;
            }
          }
        }
      }
    }
    .back_top_dialog_header {
      overflow: hidden;
      width: 100%;
      height: 58px;
      font-size: 0;
      background: #5874d8;
      -webkit-border-radius: 5px 5px 0 0;
      -moz-border-radius: 5px 5px 0 0;
      border-radius: 5px 5px 0 0;
    }
  }
}

.back_top_dialog .m-lr-0 {
  margin-left: 0;
  margin-right: 0;
}
</style>

<style>
.back_top_dialog .select_color .set_one_level .title {
  margin-right: 8px;
  display: none;
}

.back_top_dialog .select_color .set_one_level {
  position: absolute;
  left: 202px;
  top: 1px;
}
</style>



// WEBPACK FOOTER //
// src/view/back_top/edit.vue